"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureBuffer;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint-env: browser */

/**
 * Ensures the provider buffer is, indeed, an ArrayBuffer; converts File and
 * Blob objects to ArrayBuffers.
 * @param {mixed} buffer
 * @returns {Promise<ArrayBuffer>}
 */
function ensureBuffer(buffer) {
  if (buffer instanceof ArrayBuffer) {
    return _promise.default.resolve(buffer);
  }
  if (buffer.toArrayBuffer) {
    return _promise.default.resolve(buffer.toArrayBuffer());
  }
  if (buffer.buffer) {
    return _promise.default.resolve(buffer.buffer);
  }
  return new _promise.default(function (resolve, reject) {
    var fr = new FileReader();
    fr.onload = function onload() {
      resolve(new Uint8Array(this.result));
    };
    fr.onerror = reject;
    fr.readAsArrayBuffer(buffer);
  });
}
//# sourceMappingURL=ensure-buffer.browser.js.map
